import { useState, useEffect } from 'react'

interface UseDebouncedOptions<T> {
  delay?: number
  onChange?: (value: T) => void
}

export function useDebounce<T>(initialValue: T, options: UseDebouncedOptions<T> = {}) {
  const { delay = 300, onChange } = options
  const [value, setValue] = useState<T>(initialValue)
  const [debouncedValue, setDebouncedValue] = useState<T>(initialValue)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(value)
      onChange?.(value)
    }, delay)

    return () => clearTimeout(timeoutId)
  }, [value, delay, onChange])

  return {
    value,
    debouncedValue,
    setValue,
    setDebouncedValue,
  }
}
